import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getUnableNum as _getUnableNum } from '@/services/http';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.menus = [{
      title: '个人账户',
      isOpen: true,
      child: [{
        id: 1,
        title: '个人中心',
        link: '/user',
        name: 'user'
      }, {
        id: 11,
        title: '优惠券',
        link: '/coupon',
        name: 'coupon'
      }, {
        id: 2,
        title: '个人信息',
        link: '/userinfor',
        name: 'userInfor'
      }, {
        id: 10,
        title: '消息通知',
        link: '/notifys',
        name: 'notifys'
      }, {
        id: 3,
        title: '安全设置',
        link: '/securityset',
        name: 'securitySet'
      }, {
        id: 4,
        title: '地址管理',
        link: '/address',
        name: 'address'
      }]
    }, {
      title: '交易管理',
      isOpen: true,
      child: [{
        id: 5,
        title: '我的订单',
        link: '/order-list',
        name: 'orderList'
      },
      // {
      //   id: 6,
      //   title: '评价晒单',
      //   link: '/evaluation-list',
      //   name: 'evaluationList'
      // },
      {
        id: 7,
        title: '售后服务',
        link: '/exchange-list',
        name: 'exchangeList'
      }]
    }, {
      title: '客户服务',
      isOpen: true,
      child: [{
        id: 8,
        title: '发票资质',
        link: '/invoice',
        name: 'invoice'
      }]
    }];
    _this.name = '';
    _this.unableNum = 0;
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      if (this.$route.name === 'grade' || this.$route.name === 'integral' || this.$route.name === 'integralDetails') {
        this.name = 'user';
      } else {
        this.name = this.$route.name ? this.$route.name : '';
      }
      this.getUnableNum();
    }
  }, {
    key: "getUnableNum",
    value: function () {
      var _getUnableNum2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _getUnableNum({
                companyId: 1
              });
            case 2:
              res = _context.sent;
              if (res.data.code === 100) {
                this.unableNum = res.data.data;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getUnableNum() {
        return _getUnableNum2.apply(this, arguments);
      }
      return getUnableNum;
    }() // @Watch('$route')
    // routechange() {
    //   this.name = String(this.$route.name);
    // }
  }, {
    key: "changeChild",
    value: function changeChild(item) {
      this.$router.push(item.link);
      // if (item.name === 'orderList') {
      //   window.location.href = '/order-list';
      // }
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  name: 'NavMenu'
})], default_1);
export default default_1;